var _circle, _g, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApiGatewayLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#E53935",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#C62828",
      stopOpacity: 1
    }
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 48,
    fill: "url(#grad1)",
    stroke: "#B71C1C",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50,50)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 8,
    fill: "white",
    stroke: "#E53935",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 0,
    y2: -25,
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 22,
    y2: -12,
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 22,
    y2: 12,
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 25,
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: -22,
    y2: 12,
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: -22,
    y2: -12,
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -25,
    r: 4,
    fill: "white",
    stroke: "#E53935",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: -12,
    r: 4,
    fill: "white",
    stroke: "#E53935",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 12,
    r: 4,
    fill: "white",
    stroke: "#E53935",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 25,
    r: 4,
    fill: "white",
    stroke: "#E53935",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -22,
    cy: 12,
    r: 4,
    fill: "white",
    stroke: "#E53935",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -22,
    cy: -12,
    r: 4,
    fill: "white",
    stroke: "#E53935",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 5,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 6,
    fontWeight: "bold",
    fill: "#E53935"
  }, "API"))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 48,
    fill: "none",
    stroke: "#B71C1C",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiGatewayLogo);
export default __webpack_public_path__ + "static/media/api_gateway_logo.00a5bd342ae06f522a96fbb3db30f41d.svg";
export { ForwardRef as ReactComponent };